import * as React from "react";
import { Svg, Defs, Pattern, Rect, SvgProps } from "react-native-svg";

import { getStripesColors, StripesColorType } from "./stripeColors";

type StripesProps = SvgProps & {
  type: StripesColorType;
  testID?: string;
};

export const Stripes = ({ type, testID, ...rest }: StripesProps) => {
  const { primaryFill, secondaryFill } = getStripesColors(type);

  const patternId = `stripePattern-${type}`;

  return (
    <Svg width="100%" height="100%" testID={testID} {...rest}>
      <Defs>
        <Pattern
          id={patternId}
          width="12"
          height="12"
          patternTransform="rotate(45)"
          patternUnits="userSpaceOnUse"
        >
          <Rect x="0" y="0" width="6" height="12" fill={primaryFill} />
          <Rect x="6" y="0" width="6" height="12" fill={secondaryFill} />
        </Pattern>
      </Defs>
      <Rect fill={`url(#${patternId})`} width="100%" height="100%" />
    </Svg>
  );
};
